import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import type { FilterWidget } from '@sorare/core/src/lib/filters';

import { GameweekFilter } from 'searchCards';
import { BackendGameweekFilter } from 'searchCards/FixtureFilter';
import { DropdownFilter } from 'searchCommonPlayer/DropdownFilter';
import {
  BackendFavoriteFilter,
  FavoriteFilter,
} from 'searchCommonPlayer/FavoriteFilter';
import {
  BackendFloorPricesDropdownFilter,
  FloorPricesDropdownFilter,
} from 'searchCommonPlayer/FloorPricesDropdownFilter';
import {
  BackendStartersFilter,
  StartersFilter,
} from 'searchCommonPlayer/StartersFilter';

type Props = {
  dropdownFilters?: FilterWidget[];
  hideFavoriteFilter?: boolean;
};
const ScheduleFilter = () => {
  return <DropdownFilter key="gameweek" widget={GameweekFilter} />;
};

const BackendScheduleFilter = () => {
  return <DropdownFilter key="gameweek" widget={BackendGameweekFilter} />;
};
export const Segment = ({
  dropdownFilters = [],
  hideFavoriteFilter,
}: Props) => {
  const { sport } = useSportContext();
  const segments = [
    ...(sport === Sport.FOOTBALL
      ? [<StartersFilter key="starter" />, <ScheduleFilter key="schedule" />]
      : []),

    !hideFavoriteFilter ? [<FavoriteFilter key="favorite" />] : [],
    <FloorPricesDropdownFilter key="floor-prices" />,
    ...dropdownFilters.map(widget => (
      <DropdownFilter key={widget.key} widget={widget} />
    )),
  ];

  return <Horizontal>{segments}</Horizontal>;
};

export const BackendSegment = ({
  dropdownFilters = [],
  hideFavoriteFilter,
}: Props) => {
  const { sport } = useSportContext();
  const segments = [
    ...(sport === Sport.FOOTBALL
      ? [
          <BackendStartersFilter key="starter" />,
          <BackendScheduleFilter key="schedule" />,
        ]
      : []),

    !hideFavoriteFilter ? [<BackendFavoriteFilter key="favorite" />] : [],
    <BackendFloorPricesDropdownFilter key="floor-prices" />,
    ...dropdownFilters.map(widget => (
      <DropdownFilter key={widget.key} widget={widget} />
    )),
  ];

  return <Horizontal>{segments}</Horizontal>;
};
